import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectOutletActivationComponent } from './select-outlet-activation.component';

const routes: Routes = [
  {
    path: '',
    component: SelectOutletActivationComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectOutletActivationRoutingModule {}
